import React from 'react';
import CaseManagementProvider from '../../lib/context/ManageCaseContext';
import { useQuery } from '@tanstack/react-query';
import useApi from '../../hooks/useApi';
import { ActionDropdown, ActionItem } from '../Table/TableDataView';
import useCaseManagementActions from '../../hooks/useCaseManagementActions';
import styled from '@emotion/styled';

type CaseActionMenuProps = {
  caseId: string;
  extraActions?: ActionItem[];
  refetchFn?: () => void;
};

const StyledActionDropdown = styled(ActionDropdown)`
  .action-dropdown-toggle {
    font-size: 1.5rem;
  }
`;

const CaseActionMenu = ({ caseId, extraActions, refetchFn }: CaseActionMenuProps) => {
  const { Api } = useApi();

  const { data: caseDetails, refetch: refetchCaseDetails } = useQuery({
    queryKey: ['cases', caseId],
    queryFn: async () => {
      const response = await Api.cases.searchForCases({ case: caseId });

      return response?.data?.cases?.[0] || null;
    },
    enabled: !!caseId
  });

  const { generateCaseActions } = useCaseManagementActions({
    refetchFn: () => {
      refetchFn?.();
      refetchCaseDetails();
    }
  });

  if (!caseDetails) return null;

  const caseActions = generateCaseActions(caseDetails);

  const mergedActions = extraActions?.length ? [...caseActions, ...extraActions] : caseActions;

  return (
    <StyledActionDropdown customDataTestID="timeline-case-action-dropdown" actionItems={mergedActions} rowData={{}} />
  );
};

const ActionMenuWithContextProvider = (props: CaseActionMenuProps) => {
  return (
    <CaseManagementProvider>
      <CaseActionMenu {...props} />
    </CaseManagementProvider>
  );
};

export default ActionMenuWithContextProvider;
